//import { checkTokenExists, setToken } from '../helpers/auth';
import api from './api';
import { setUserData } from '../actions/auth';
import localforage from "localforage";

export const SET_CERTIFICATE_DATA = 'SET_CERTIFICATE_DATA';
export const UPDATE_PROFILE_DATA = 'UPDATE_PROFILE_DATA';

export const fetchCertificate = () => dispatch => {
  return window.axios.get(api.profile.certificate)
    .then((response) => {
      dispatch(setCertificateData(response.data.certificate, response.data.removals));
      return Promise.resolve({ ...response.data });
    })
    .catch(error => {
      return Promise.reject(error)
    });
};

export const updateProfileRequest = (props) => dispatch => {
  return window.axios.post(api.profile.update, props)
        .then((response) => {
          props.user.email = props.email;
          props.user.language = props.language;
          dispatch(setUserData(props.user));
          return Promise.resolve({ ...response.data });
        }).catch(error => {
          return Promise.reject(error)
        });
}

export const updateLocaleRequest = (props) => dispatch =>  {
    if (navigator.onLine) {
        return window.axios.post(api.profile.locale, props)
            .then(async (response) => {
                window.App.locale = response.data.locale;
                window.App.translations = response.data.translations;
                props.user.language = response.data.locale;
                dispatch(setUserData(props.user));

                await localforage.setItem('bs_locale', response.data.locale);

                return Promise.resolve({ ...response.data });
            }).catch(error => {
                return Promise.reject(error);
            });
    } else {
        return localforage.getItem('bs_locale')
            .then((data) => {
                if (data) {
                    window.App.locale = data.locale;
                    window.App.translations = data.translations;
                    props.user.language = data.locale;
                    dispatch(setUserData(props.user));
                    return Promise.resolve({ ...data });
                } else {
                    return Promise.reject(new Error('No locale data available offline.'));
                }
            }).catch(error => {
                return Promise.reject(error);
            });
    }
}

export const setCertificateData = (certificate,removals) => ({
  type: SET_CERTIFICATE_DATA,
  certificate,
  removals
});